"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    link: {
      display: 'inline-block'
    },
    eyeIcon: {
      marginRight: spacing(2)
    }
  };
});

var PreviewLink = function PreviewLink(_ref2) {
  var link = _ref2.link,
      children = _ref2.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: link,
    target: "_blank",
    className: (0, _classnames.default)('Body-Regular-Center-Link-Bold', classes.link),
    "data-testid": "PreviewLink"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "eye",
    fontSize: 1,
    className: classes.eyeIcon
  }), children);
};

var _default = /*#__PURE__*/(0, _react.memo)(PreviewLink);

exports.default = _default;